import {BETA_FEATURES} from './types/enums/BETA_FEATURES';

// products
export const invoices_feature_flag = BETA_FEATURES.Invoices;
export const order_selected_date_feature_flag = BETA_FEATURES.Order_selected_date;
